import React from "react";
import PropTypes from "prop-types";
import styled from "@emotion/styled";

const NavLogoImg = styled.img`
    label: NavLogoImg;
    //Mobile-landscape (and larger)
    @media (min-width: 320px) {
        padding: 0;
        margin-left: 1em;
        width: 93px;
        height: 40px;
    }
    //Mobile-landscape (and larger)
    @media (min-width: 480px) {
        padding: 0;
        margin-left: 1em;
        width: 93px;
        height: 40px;
    }
    // Tablet-portrait (and larger)
    @media (min-width: 768px) {
        width: 100px;
        margin: 10px 0 10px 30px;
    }
    // Tablet-landscape (and larger)
    @media (min-width: 992px) {
        width: 100px;
        margin: 10px 0 10px 30px;
    }
    // Laptops (and longer)
    @media (min-width: 1200px) {
        width: 100px;
        margin: 10px 0 10px 30px;
    }
`;

const Logo = ({ link, linkLabel, imageSource }) => (
    <a href={link}>
        <NavLogoImg src={imageSource} alt={linkLabel} />
    </a>
);

Logo.propTypes = {
    link: PropTypes.string,
    linkLabel: PropTypes.string,
    imageSource: PropTypes.string
};

Logo.defaultProps = {
    linkLabel: "Rosetta Stone",
    link: "/",
    imageSource: "https://www.rosettastone.com/lp/home_2018/assets/rs_logo_original.svg"
};
export default Logo;
